import { TPermissionAction } from '@/shared/features/permissions/actions';
import { TPermissionCheck } from '@/shared/features/permissions/permission-check.types';
import { TRbacConfig } from '@/shared/features/rbac/context/rbac-config-context.types';

const identCheck = (
  action: TPermissionAction | TPermissionAction[],
  ids?: string | string[],
  any?: boolean,
): TPermissionCheck => ({ action, ids, any });

const identCheckWhen = <TSubject>(
  subject: TSubject | undefined,
  build: (subject: TSubject) => TPermissionCheck,
): TPermissionCheck | undefined => (subject ? build(subject) : undefined);

/**
 * Console permission checks consumed by shared RBAC UI. All checks target the
 * `ident:*` action prefix used by console policies.
 */
export const consoleRbacPermissionChecks: TRbacConfig['rbacPermissionChecks'] =
  {
    createUser: identCheck('ident:createUser'),
    createRole: identCheck('ident:createUserRole'),
    readUser: (userId) =>
      identCheckWhen(userId, (id) => identCheck('ident:readUser', id)),
    userActions: (user) =>
      identCheckWhen(user, ({ userId }) =>
        identCheck(['ident:updateUser', 'ident:deleteUser'], userId, true),
      ),
    updateUser: (user) =>
      identCheckWhen(user, ({ userId }) =>
        identCheck('ident:updateUser', userId),
      ),
    deleteRoles: (roles) =>
      identCheckWhen(roles, (items) =>
        identCheck(
          'ident:deleteUserRole',
          items.map(({ userRoleId }) => userRoleId),
        ),
      ),
    deleteUsers: (users) =>
      identCheckWhen(users, (items) =>
        identCheck(
          'ident:deleteUser',
          items.map(({ userId }) => userId),
        ),
      ),
    updateRole: (role) =>
      identCheckWhen(role, ({ userRoleId }) =>
        identCheck('ident:updateUserRole', userRoleId),
      ),
    batchUpdateRoles: (groupId) => identCheck('ident:updateUserRole', groupId),
    batchUpdateUsers: (groupId) => identCheck('ident:updateUser', groupId),
  };
